import gql from 'graphql-tag';
const query = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token)
  }
`;
export default query;
